import $ from 'jquery';
import { applyFilters } from '@wordpress/hooks';

const screenBreakpoints = {
	xxl: 1400,
	xl: 1220,
	lg: 1024,
	md: 768,
	sm: 576,
};

const getScreenBreakpoints = ( size => {
	let breakPoint = 0;

	if ( typeof screenBreakpoints[ size ] !== 'undefined' ) {
		breakPoint = screenBreakpoints[ size ];
	}

	return applyFilters( 'cga_screen_break_points', breakPoint, size );
});

const detectTouchDevice = () => {
	if ( 'ontouchstart' in document.documentElement ) {
		$( 'html' ).addClass( 'touch-device' );
	}
};

const getScreenWidth = () => {
	let screenWidth = window.innerWidth;
	if ( screen.availWidth < screenWidth ) {
		screenWidth = screen.availWidth;
	}

	return screenWidth;
}

const getHeightElement = ( an_item ) => {
	let height_el = null;
	const block_group = an_item.querySelector( '.gradient-container' );
	if ( block_group !== null ) {
		height_el = block_group;
	} else {
		const heightElement = an_item.querySelector( '.height-element' );
		if ( heightElement !== null ) {
			height_el = heightElement;
		} else {
			height_el = an_item;
		}
	}
	return height_el;
};

const getItemHeight = ( items ) => {
	let itemHeight = 0;
	items.forEach( an_item => {
		const height_el = getHeightElement( an_item );
		if ( height_el !== null ) {
			const computedStyle = window.getComputedStyle( height_el );
			const thisHeight = height_el.clientHeight + parseFloat( computedStyle.paddingTop ) + parseFloat( computedStyle.paddingBottom );
			if ( thisHeight > itemHeight ) {
				itemHeight = thisHeight;
			}
		}

	});

	return itemHeight;
};

const setItemHeight = ( items, itemHeight ) => {
	items.forEach( an_item => {
		const height_el = getHeightElement( an_item );
		if ( height_el !== null ) {
			height_el.style.height = `${itemHeight}px`;
		}
	});
};

const resetItemHeight = ( items ) => {
	items.forEach( an_item => {
		const height_el = getHeightElement( an_item );
		if ( height_el !== null ) {
			height_el.style.height = 'unset';
		}
	});
};

export { screenBreakpoints, getScreenBreakpoints, detectTouchDevice, getScreenWidth, getItemHeight, setItemHeight, resetItemHeight };